import React, { useState } from 'react'
import { reactular } from '@vendhq/reactular'
import { useT } from '@transifex/react'
import { TextAreaInput, InputCharLimit } from '@lightspeed/design-system-react'
import DOMPurify from 'dompurify'

export const INPUT_CHAR_THRESHOLD = 51
export const INPUT_CHAR_LIMIT = 255

interface Props {
  initialNote?: string
  disabled?: Readonly<boolean>
  onNoteUpdate?: (newNote: string) => void
  setFormValid?: (valid: boolean) => void
}

export const SetCashFloatNotes: React.FC<Props> = ({
  initialNote = '',
  disabled = false,
  onNoteUpdate,
  setFormValid,
}) => {
  const t = useT()
  const [note, setNote] = useState(initialNote === null ? '' : initialNote)

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const sanitizedValue = DOMPurify.sanitize(event.target.value)
    setNote(sanitizedValue)

    if (onNoteUpdate) {
      onNoteUpdate(sanitizedValue)
    }

    if (setFormValid) {
      setFormValid(sanitizedValue.length <= INPUT_CHAR_LIMIT)
    }
  }

  return (
    <div className="vd-mb5">
      <div className="vd-label">
        Notes <span className="vd-text-supplementary">Optional</span>
      </div>
      <div className="vd-value">
        <TextAreaInput
          disabled={disabled}
          name="note"
          value={note}
          onChange={handleChange}
          placeholder={t('Enter a note', {
            _context: 'Placeholder',
          })}
          rows={2}
          hasError={note.length > INPUT_CHAR_LIMIT}
        />
      </div>
      <InputCharLimit
        threshold={INPUT_CHAR_THRESHOLD}
        limit={INPUT_CHAR_LIMIT}
        value={note}
      />
    </div>
  )
}

export const SetCashFloatNotesComponent = reactular<Props>(SetCashFloatNotes, [
  'initialNote',
  'disabled',
  'onNoteUpdate',
  'setFormValid',
])
